import { observable, action } from 'mobx';

class CourseStore {
  @observable courses = [];
  @observable closestCourse = {};
  @observable errors = {};

  @action
  setCourses = courses => {
    this.courses = courses;
  }

  @action
  setError = errors => {
    this.errors = errors;
  }

  @action
  setCourse = closest => {
    // const now = new Date();
    // let closest = {};

    // this.courses.forEach(course => {
    //   const date = new Date(course.on_site_date);

    //   if(closest) {
    //     if(date >= now && (date < new Date(closest.on_site_date) || date < closest.on_site_date)) {
    //        closest = course;
    //     }
    //   } else {
    //     if(date >= now) {
    //       closest = course;
    //     }
    //   }
    // });

    this.closestCourse = closest;
  }
}

export default new CourseStore();



// WEBPACK FOOTER //
// ./src/stores/CourseStore.js